import { useCallback, useMemo } from "react";
import { useFetchDataForTwoLines } from "../../../hooks/useFetchDataForTwoLines";
import { useXAxisFormat } from "../../../hooks/useXAxisFormat";
import { KPI_CODES } from "../../../kpiCodes";
import dayjs from "../../../../../configs/dayjs";

export const useFetchData = (isRecalculated: boolean, granularity: number) => {
  const { xAxisFormat, tooltipFormat } = useXAxisFormat(granularity);

  const kpiCodes = useMemo(() => {
    if (granularity === 1) {
      return [
        KPI_CODES.PAYMENTS_AMOUNTS_TODAY,
        KPI_CODES.DISBURSEMENTS_AMOUNTS_TODAY,
      ];
    } else if (granularity === 2) {
      return [
        KPI_CODES.PAYMENTS_AMOUNTS_THIS_MONTH,
        KPI_CODES.DISBURSEMENTS_AMOUNTS_THIS_MONTH,
      ];
    }

    return [
      KPI_CODES.PAYMENTS_AMOUNTS_THIS_YEAR,
      KPI_CODES.DISBURSEMENTS_AMOUNTS_THIS_YEAR,
    ];
  }, [granularity]);

  const getFormattedItem = useCallback(
    (item: any, kpi: any) => {
      const type: string = item.code.split(".")[0];

      return {
        month: dayjs(kpi.createdAt).format(xAxisFormat),
        type,
        value: kpi.value,
        tooltipValue: dayjs(kpi.createdAt).format(tooltipFormat),
        isMain: type === "Payments",
      };
    },
    [tooltipFormat, xAxisFormat],
  );

  const { data, isLoading } = useFetchDataForTwoLines(
    granularity,
    isRecalculated,
    kpiCodes,
    getFormattedItem,
  );

  return { data, isLoading };
};
